import React, { useState, useEffect } from "react";
import '../../style.css';
import Plot from 'react-plotly.js';
import { Select } from "antd";
import { toOptionsList } from "../../utilities/utilFunctions";
import CountByYearTable from "./visualizations/CountByYearTable";
import CountByLocAndYearTable from "./visualizations/CountByLocAndYearTable";
import TraitLocPlot from "./visualizations/TraitLocPlot";
import TraitLocAndYearsPlot from "./visualizations/TraitLocAndYearsPlot";
import AverageByVarietyPlot from "./visualizations/AverageByVarietyPlot";

function BlupsMeansDataVisualizations(props) {
    const [selectedTrait, setSelectedTrait] = useState('')
    const [traitOptions, setTraitOptions] = useState([])

    useEffect(() => {
        setTraitOptions(toOptionsList(props.traits))
    }, [])

    const handleSelectedTraitChange = (selected) => {
        setSelectedTrait(selected);
    }
    return (
        <div>
            <div>
                <CountByYearTable
                    data={props.countByYearData}
                    years={props.years}
                />
                <br />
                <div className="mx-3">
                    Select Trait:
                    &nbsp;
                    <Select placeholder={'Select Trait'} options={traitOptions} style={{ width: '200px' }} onSelect={handleSelectedTraitChange}></Select>
                </div>
                <br />
                {selectedTrait !== '' &&
                    <div>
                        <CountByLocAndYearTable
                            data={ props.countByLocYearData ? props.countByLocYearData[selectedTrait] : null}
                            trait={selectedTrait}
                        />
                        <br />
                        <div className="row">
                            <div className="col-xl">
                                <div className="container">
                                    <div className="card my-3 mx-3 px-2">
                                        <div className="card-body align-self-center">
                                            <TraitLocPlot
                                                data={props.data}
                                                trait={selectedTrait}
                                                width={500}
                                                height={400}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl">
                                <div className="container">
                                    <div className="card my-3 mx-3 px-2">
                                        <div className="card-body align-self-center">
                                            <TraitLocAndYearsPlot
                                                data={props.data}
                                                trait={selectedTrait}
                                                width={500}
                                                height={400}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="card my-3 mx-3 px-2">
                            <div className="card-body align-self-center">
                                <AverageByVarietyPlot
                                    data={props.traitAverageData}
                                    trait={selectedTrait}
                                />
                            </div>
                        </div>
                    </div>
                }

            </div>

        </div>


    )


};

export default BlupsMeansDataVisualizations